import { tItemsFromApi } from '@/Interfaces/caseComponentsLib';
import { tStorePresetsLib } from '@/Interfaces/presets';
import { getCaseDataByXmlId } from '@/libs/libGetters';
import { parseUrlConfig } from '@/libs/parseUrlConfig';

function getQueryParam(url: string, param: string) {
    // const queryString = url.split('#')[1];
    // if (!queryString) {
    //     return null;
    // }

    const urlParams = new URLSearchParams(url);
    return urlParams.get(param);
}

function getSubstring(inputString: string, startMarker: string) {
    const endMarker = '&';

    // Находим начальный индекс начального маркера
    let startIndex = inputString.indexOf(startMarker);
    if (startIndex === -1) {
        return ''; // Если начальный маркер не найден, возвращаем пустую строку
    }

    // Смещаемся на длину начального маркера для получения начала подстроки
    startIndex += startMarker.length;

    // Находим конечный индекс конечного маркера, начиная поиск с позиции после начального маркера
    const endIndex = inputString.indexOf(endMarker, startIndex);

    // Если конечный маркер не найден, возвращаем оставшуюся часть строки
    if (endIndex === -1) {
        return inputString.substring(startIndex);
    }

    // Возвращаем подстроку между начальным и конечным маркером
    return inputString.substring(startIndex, endIndex);
}

const presetURLDemo = 'https://configurator.safe.ru.dev2.nowmedia.ru/?currency=&role=&host=https%3A%2F%2Fdealer.safe.dev3.nowmedia.ru%2F3/#/configurator?config=|sh_amh_tc/false/21/0|sh_amh_tc/false/19/0|shi_amh_tc/false/19/0|shi_amh_tc/false/13/0|shi_amh_tc/false/7/0|amh_tc_125/false/1/0|amh_tc_125/false/3/0|amh_tc_125/false/5/0|amh_tc_60/false/7/0|amh_tc_60/false/9/0&toolChest=|bnamh_tc|clrFrame%23999993|clrFace%2300067F|drClosefalse|exDPrId||dS|&locker_lid=4f548abc-23fb-4a71-a2b2-daff9f33afcc';

export function getPresets(data: tItemsFromApi) {
    const presetItems = data.filter(item => item.parentId !== null);
    const storePresetsOut: tStorePresetsLib = [];

    presetItems.forEach(item => {
        if (!item.parentId) {
            return;
        }

        const caseType = getCaseDataByXmlId(item.parentId)?.key;
        // const caseType = 'AMH-TC';

        if (!caseType) {
            console.error('Не определён тип шкафа');
            return;
        }
        if (!item.preset) {
            console.error('Нет URL пресета');
            return;
        }

        const urlConfig = getSubstring(item.preset, 'config=');
        const urlToolChest = getSubstring(item.preset, 'toolChest=');

        if (!urlConfig || !urlToolChest) {
            console.error('Ошибка при парсинге URL пресета');
            return;
        }
        const jsonData = parseUrlConfig(urlConfig,  urlToolChest);

        if (!jsonData) {
            console.error('Ошибка при восстановлении пресета из URL');
            return;
        }
        storePresetsOut.push({
            id: crypto.randomUUID(),
            caseModel: caseType,
            url: item.preset,
            json: jsonData,
            image: item.previewPicture ?? undefined,
        });
    });

    // console.log('!presets', storePresetsOut);
    return storePresetsOut;
}
